import { get, postAuth } from "./base.service";
import { CONTROLLER, ACTION } from "../utilities/api.constants";
import { extractApiErrorMessage } from "../utilities/apiErrorMessage";
import {
  parseApiPayload,
  getBaseResponseError,
  extractBaseResponseData,
} from "../utilities/baseResponse";

export const getCampaigns = async (query) => {
  try {
    const httpResponse = await get(
      CONTROLLER.CALCULATION + ACTION.GET_CAMPAIGNS + query
    );
    const parsed = parseApiPayload(httpResponse?.data);
    const apiError = getBaseResponseError(
      parsed,
      "Kampanyalar yüklenirken bir hata oluştu."
    );

    if (apiError) {
      throw new Error(apiError);
    }

    const list = extractBaseResponseData(parsed);

    if (!Array.isArray(list) || list.length === 0) {
      return null;
    }

    return list;
  } catch (error) {
    const message = extractApiErrorMessage(
      error,
      "Kampanyalar yüklenirken bir hata oluştu."
    );
    throw new Error(message);
  }
};

export const getPaymentPlan = async (query) => {
  const result = await get(
    CONTROLLER.CALCULATION + ACTION.GET_PAYMENT_PLAN + query
  );
  return result.data.data;
};

export const savePersonalInfo = async (data) => {
  const result = await postAuth(
    CONTROLLER.CALCULATION + ACTION.SAVE_PERSONAL_INFO,
    data
  );
  return result.data.data;
};

export const saveAddress = async (address) => {
  const result = await postAuth(
    CONTROLLER.CALCULATION + ACTION.SAVE_ADDRESS,
    address
  );
  return result.data.data;
};

export const sendSmsOfferValidation = async () => {
  const result = await get(
    CONTROLLER.MEMBER + ACTION.SEND_SMS_OFFER_VALIDATION
  );
  return result.data.data;
};

export const checkIfCustomerHasAddress = async () => {
  const result = await get(
    CONTROLLER.MEMBER + ACTION.CHECK_IF_CUSTOMER_HAS_ADDRESS
  );
  return result.data.data;
};

export const checkPersonalInformation = async () => {
  const result = await get(
    CONTROLLER.MEMBER + ACTION.CHECK_PERSONEL_INFORMATION
  );
  return result.data.data;
};

export const saveMembership = async (member) => {
  const result = await postAuth(
    CONTROLLER.MEMBER + ACTION.SAVE_MEMBERSHIP,
    member
  );
  return result.data.data;
};

export const memberInstallmentControl = async (
  orgTuruId,
  orgSistemiId,
  taksitSayisi
) => {
  const control = await get(
    CONTROLLER.MEMBER +
      ACTION.MEMBER_INSTALLMENT_CONTROL +
      "?orgTuruId=" +
      orgTuruId +
      "&orgSistemiId=" +
      orgSistemiId +
      "&taksitSayisi=" +
      taksitSayisi
  );
  if (control != null || control.data != null || control.data.messages != null ||  control.data.messages.length != 0) {
    return control?.data?.messages[0];
  }
  return null;
};
